import { TYPES } from '@/entities/fields'
import i18n from '@/lang/i18n'

const DATAGRID_CONFIG = {
    hasInputFilter: false,
    filterable: true,
    sideBar: true,
    cleanFiltersButton: false,
    fitResponsive: true,
    editable: false,
}

const COLUMNS = [
    {
        headerName: i18n.t('audit.columns.createdAt'),
        field: 'createdAt',
        type: TYPES.DATETIME,
        sort: 'desc',
    },
    {
        headerName: i18n.t('audit.columns.user'),
        field: 'userName',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.email'),
        field: 'userEmail',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.entity'),
        field: 'entityLabel',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.format'),
        field: 'formatLabel',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.status'),
        field: 'statusLabel',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.records'),
        field: 'recordsLabel',
        type: TYPES.STRING,
    },
    {
        headerName: i18n.t('audit.columns.size'),
        field: 'sizeLabel',
        type: TYPES.STRING,
    },
]

export default {
    config: DATAGRID_CONFIG,
    columns: COLUMNS,
}
